import React, { useEffect } from "react";
import { Routes, Route, useLocation, Link } from "react-router-dom";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

// Analytics
import { initGA, logPageView } from "./analytics";

// Hooks & Utilities
import usePageLoad from "./hooks/usePageLoad";
import useContentProtection from "./hooks/useContentProtection"; // ✅ new hook
import ScrollToTop from "./components/ScrollToTop.js";

// Components
import Navbar from "./components/navbar";
import Footer from "./components/footer.jsx";
import LoadingRing from "./components/LoadingRing";

// Main Pages
import Home from "./components/home";
import Tours from "./components/tours";
import Contact from "./components/contact";
import OsiligiPage from "./components/osiligi";
import About from "./components/about.jsx";
import Gallery from "./components/gallery.jsx";
import Accomodation from "./components/accomodations.jsx";
import Destinations from "./components/destinations.jsx";
import CustomizeSafari from "./components/customizesafari.jsx";
import OsiligiSupportForm from "./components/OsiligiSupportForm.jsx";
import ThankYou from "./components/thankyou.jsx";
import Flysafari from "./components/flysafari.jsx";
import TravelTips from "./components/travelTips.jsx";

// Safari Packages
import Packageosiligi from "./components/Osiligi-Clinic-Safari.jsx";
import Packagenakuru from "./components/Bush-BeachSafari.jsx";
import Packagemara from "./components/Mara-DeepDive.jsx";
import Packagefamily from "./components/RiftValleyClassic.jsx";

// Places
import Mara from "./components/places/mara";
import Lnaivasha from "./components/places/lnaivasha";
import LakeNakuru from "./components/places/nakuru.jsx";
import Amboseli from "./components/places/amboseli.jsx";
import Samburu from "./components/places/samburu.jsx";
import Tsavo from "./components/places/tsavo.jsx";
import Olpejeta from "./components/places/olpejeta.jsx";
import Shela from "./components/places/shela.jsx";
import AmboseliTsavopack from "./components/Amboseli+Tsavo.jsx";
import OlpejetaSamburu from "./components/Conservation-Safari.jsx";
import KenyaClassic from "./components/Kenya-Classic.jsx";
import CrossBorderSafari from "./components/CrossBorderSafari.jsx";
import CulturalSafari from "./components/Maasai-CultureSafari.jsx";

function App() {
  const location = useLocation();
  const isLoading = usePageLoad();

  // ✅ Initialize content protection
  useContentProtection();

  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);

  // Log page views
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  // === Loading Spinner ===
  if (isLoading) {
    return <LoadingRing />;
  }

  return (
    <>
      {/* Navbar */}
      <Navbar />
      <ScrollToTop />

      {/* Main content */}
      <main style={{ paddingTop: "60px" }}>
        <Routes location={location} key={location.key}>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/osiligi" element={<OsiligiPage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/about" element={<About />} />
          <Route path="/accomodations" element={<Accomodation />} />

          {/* Safari Packages */}
          <Route path="/Osiligi-Clinic-Safari" element={<Packageosiligi />} />
          <Route path="/Mara-DeepDive" element={<Packagemara />} />
          <Route path="/Bush-BeachSafari" element={<Packagenakuru />} />
          <Route path="/RiftValleyClassic" element={<Packagefamily />} />
          <Route path="/Amboseli+Tsavo" element={<AmboseliTsavopack />} />
          <Route path="/Conservation-Safari" element={<OlpejetaSamburu />} />
          <Route path="/CrossBorderSafari" element={<CrossBorderSafari />} />
          <Route path="/Kenya-Classic" element={<KenyaClassic />} />
          <Route path="/flysafari" element={<Flysafari />} />
          <Route path="/Maasai-CultureSafari" element={<CulturalSafari />} />

          {/* Places */}
          <Route path="/places/mara" element={<Mara />} />
          <Route path="/places/lnaivasha" element={<Lnaivasha />} />
          <Route path="/places/nakuru" element={<LakeNakuru />} />
          <Route path="/places/amboseli" element={<Amboseli />} />
          <Route path="/places/samburu" element={<Samburu />} />
          <Route path="/places/tsavo" element={<Tsavo />} />
          <Route path="/places/olpejeta" element={<Olpejeta />} />
          <Route path="/places/shela" element={<Shela />} />
          <Route path="/customizesafari" element={<CustomizeSafari />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/travelTips" element={<TravelTips />} />
          <Route path="/OsiligiSupportForm" element={<OsiligiSupportForm />} />


          {/* 404 Fallback */}
          <Route
            path="*"
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                  textAlign: "center",
                  backgroundColor: "#f8f5ee",
                  color: "#2c3e50",
                  padding: "2rem",
                }}
              >
                <h1 style={{ fontSize: "6rem", marginBottom: "1rem" }}>404</h1>
                <h2 style={{ marginBottom: "1rem" }}>Page Not Found</h2>
                <p style={{ marginBottom: "2rem", maxWidth: "400px" }}>
                  Oops! The page you're looking for doesn't exist or has been moved.
                </p>
                <Link
                  to="/"
                  style={{
                    padding: "0.75rem 1.5rem",
                    backgroundColor: "#a48538",
                    color: "white",
                    borderRadius: "5px",
                    textDecoration: "none",
                    fontWeight: "bold",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = "#bfa76f")}
                  onMouseOut={(e) => (e.target.style.backgroundColor = "#a48538")}
                >
                  ← Back to Home
                </Link>
              </div>
            }
          />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />

      {/* Toast Container */}
      <ToastContainer
        position="top-center"
        transition={Slide}
        hideProgressBar
        closeOnClick
        draggable={false}
        pauseOnHover={false}
        newestOnTop
        autoClose={1800}
      />
    </>
  );
}

export default App;
